{
  "name": "gallery-ui",
  "version": "1.11.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test --watch=false",
    "test:watch": "ng test",
    "test:coverage": "ng test --watch=false --configuration coverage",
    "lint": "eslint -c .eslintrc.js --ext .ts src/",
    "e2e": "ng e2e",
    "swagger-gen": "curl --insecure http://host.docker.internal:4722/swagger/v1/swagger.json --output swagger.json && node_modules/@openapitools/openapi-generator-cli/bin/openapi-generator generate -i ./swagger.json -g typescript-angular -o src/app/generated/api --additional-properties ngVersion=21 --additional-properties useRxJS6=true --additional-properties modelPropertyNaming=original --type-mappings=DateTime=Date --skip-validate-spec",
    "swagger-gen-docker": "cross-env-shell docker run --rm -v $INIT_CWD:/local openapitools/openapi-generator-cli:v7.2.0 generate -i http://host.docker.internal:4722/swagger/v1/swagger.json -g typescript-angular -o /local/src/app/generated/api --additional-properties ngVersion=21 --additional-properties useRxJS6=true --additional-properties modelPropertyNaming=original --type-mappings=DateTime=Date --skip-validate-spec",
    "docker:init": "docker network create identity --driver=overlay",
    "docker:stack": "npm run docker:stack:identity && npm run docker:stack:api",
    "docker:stack:api": "docker stack deploy -c docker-compose.yml -c docker/compose/api.yml gallery_stack",
    "docker:stack:identity": "docker stack deploy -c docker-compose.yml -c docker/compose/identity.yml identity_stack",
    "docker:destroy": "docker stack rm gallery_stack identity_stack"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.10",
    "@angular/cdk": "^21.2.10",
    "@angular/common": "^21.2.10",
    "@angular/compiler": "^21.2.10",
    "@angular/core": "^21.2.10",
    "@angular/forms": "^21.2.10",
    "@angular/material": "^21.2.10",
    "@angular/platform-browser": "^21.2.10",
    "@angular/router": "^21.2.10",
    "@cmusei/crucible-common": "0.8.0",
    "@datorama/akita": "^8.0.1",
    "@datorama/akita-ng-router-store": "^7.0.0",
    "@datorama/akita-ngdevtools": "^7.0.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@kolkov/angular-editor": "^3.0.0-beta.2",
    "@mdi/font": "^7.2.96",
    "@microsoft/signalr": "^8.0.7",
    "@ngxmc/datetime-picker": "^20.1.0",
    "@popperjs/core": "^2.11.8",
    "ajv": "^8.6.0",
    "bootstrap": "^5.3.3",
    "bootstrap-scss": "^5.2.2",
    "core-js": "^3.14.0",
    "glob-parent": "^6.0.1",
    "ini": "^3.0.1",
    "lodash": "^4.17.21",
    "luxon": "^1.28.1",
    "material-design-icons": "^3.0.1",
    "ngx-clipboard": "^15.1.0",
    "node-forge": "^1.3.1",
    "oidc-client-ts": "^2.4.0",
    "rxjs": "^7.8.1",
    "rxjs-compat": "^6.6.7",
    "tslib": "^2.2.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.3.0",
    "@angular-eslint/eslint-plugin": "^21.3.0",
    "@angular-eslint/eslint-plugin-template": "^21.3.0",
    "@angular-eslint/schematics": "^21.3.0",
    "@angular-eslint/template-parser": "^21.3.0",
    "@angular/build": "^21.2.10",
    "@angular/cli": "^21.2.10",
    "@angular/compiler-cli": "^21.2.10",
    "@angular/language-service": "^21.2.10",
    "@openapitools/openapi-generator-cli": "1.0.18-3.2.0",
    "@testing-library/angular": "^19.1.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^6.9.1",
    "@testing-library/user-event": "^14.6.1",
    "@types/jasminewd2": "~2.0.9",
    "@types/node": "^24.0.0",
    "@typescript-eslint/eslint-plugin": "^8.41.0",
    "@typescript-eslint/parser": "^8.41.0",
    "@vitest/coverage-v8": "^4.1.5",
    "cross-env": "^10.1.0",
    "eslint": "^9.34.0",
    "eslint-plugin-import": "^2.32.0",
    "jasmine-spec-reporter": "~7.0.0",
    "jsdom": "^28.1.0",
    "patch-package": "^8.0.1",
    "ts-node": "~10.0.0",
    "typescript": "~5.9.3",
    "vitest": "^4.1.5"
  }
}
